import { Button, Card, Grid, Typography, Tabs, Tab, } from '@material-ui/core'
import React from 'react'
import { useStyles } from './styles'
import ReactSelect from 'react-select';
import ReactAudioPlayer from 'react-audio-player';
import Backdrop from '../../../../components/Modal/Backdrop';
import Modal from '../../../../components/Modal/Modal'
import { TabContext, TabPanel } from '@material-ui/lab';
import axiosInstance from '../../../../environment/axiosInstance'
import RecordAudio from './RecordAudio'
import UploadAudio from './UploadAudio'


import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { makeStyles, } from '@material-ui/core';

import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()

const muiTheme = createMuiTheme({});

const useStyleses = makeStyles(
    (theme: any) => {
        return {
            root: {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                },
            },
            loopIcon: {
                color: '#4D72F8',
                '&.selected': {
                    color: '#0921a9'
                },
                '&:hover': {
                    color: '#4D72F8'
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'none'
                }
            },
            playIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            pauseIcon: {
                color: '#4D72F8',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeSlider: {
                color: '#4D72F8'
            },
            progressTime: {
                color: '#6b6b6d'
            },
            mainSlider: {
                color: '#4D72F8',
                '& .MuiSlider-rail': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-track': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-thumb': {
                    color: '#4D72F8'
                }
            }
        }
    });


function UsersDepartments(props: any) {
    const classes = useStyles()
    const [value, setValue] = React.useState("2");
    const [shouldRecord, setShouldRecord] = React.useState(false)
    const [depts, setDepts] = React.useState([])
    const [teamMembers, setTeamMembers] = React.useState([])
    const handlePopupModalAdd = () => {
        setShouldRecord(!shouldRecord)
        // setopenModalAdd(!openModalAdd)
    }
    const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
        setValue(newValue);
    };

    const handleLoadMetadata = (meta: any) => {
        const { duration } = meta.target;
        const styles = makeStyles({

        })
        // console.log(duration);
    }

    const [deptValue, setDeptValue] = React.useState<any>('');
    const [teamValue, setTeamValue] = React.useState<any>('');
    const [location, setLocation] = React.useState<any>({ label: '', value: '' });


    //departments
    React.useEffect(() => {
        const departments: any = []
        if (props.closeHoursData) {
            props.closeHoursData.closeHours?.Departments?.map((item: any) => {
                var myObj = {
                    label: item.name,
                    value: item._id
                }
                departments.push(myObj)
            })
            setDepts(departments)
        }
    }, [props.closeHoursData])

    const handleDeptOnchange = (data: any) => {
        setDeptValue(data.value)
        const sendData = {
            departmentId: data.value
        }
        axiosInstance.patch(`/departments/${props.deptId}/close-hours/user-department`, sendData).then((res: any) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: toast.POSITION.TOP_RIGHT, autoClose: 1000
                })
                props.getClosedHours()
            }
        }).catch((err: any) => {
            //err
        })
    };


    //TeamMembers
    React.useEffect(() => {
        const teamMembers: any = []
        if (props.closeHoursData) {
            props.closeHoursData.closeHours?.TeamMembers?.map((item: any) => {
                var myObj = {
                    label: item.firstName + ' ' + item.lastName,
                    value: item.firstName + ' ' + item.lastName,
                    id: item._id
                }
                teamMembers.push(myObj)
            })
            setTeamMembers(teamMembers)
        }
    }, [props.closeHoursData])

    const handleTeamMembersOnchange = (data: any) => {
        setTeamValue(data.value)
        const sendData = {
            teamMemberId: data.id
        }
        axiosInstance.patch(`/departments/${props.deptId}/close-hours/user-department`, sendData).then((res: any) => {
            if (res.status === 200) {
                toast.success(res.data.message, {
                    position: toast.POSITION.TOP_RIGHT, autoClose: 1000
                })
                props.getClosedHours()
            }
        }).catch((err: any) => {
            //err
        })
    };


    // React.useEffect(() => {
    //     if (props.deptId) {
    //         const deptFilter = depts.find((dept: any) => dept.value === props.deptId?.value)
    //         setLocation(deptFilter)
    //         setDeptValue(props.deptId?.value)
    //     }
    // }, [props.deptId])



    return (
        <>
            {
                shouldRecord && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalAdd} />
                        <Modal title="Record Audio" handlePopupModal={handlePopupModalAdd}>
                            <div className={classes.divSpacing}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    className={classes.tabs}
                                    onChange={handleChange}
                                    id="editOpenHourGreetingsTab"
                                    style={{}}
                                >
                                    {/* <Tab
                                        label="Record Audio"
                                        value="1"
                                        className={value === "1" ? classes.tabActive : classes.tab}
                                    /> */}
                                    <Tab
                                        label="Upload Audio"
                                        value="2"
                                        className={value === "2" ? classes.tabActive : classes.tab}
                                    />

                                </Tabs>
                                <TabContext value={value}>
                                    <TabPanel value="1">
                                        <RecordAudio
                                            closeHoursData={props.closeHoursData}
                                            getClosedHours={props.getClosedHours}
                                            deptId={props.deptId}
                                            loading={props.loading}
                                        />
                                    </TabPanel>
                                    <TabPanel value="2">
                                        <UploadAudio
                                            closeHoursData={props.closeHoursData}
                                            getClosedHours={props.getClosedHours}
                                            deptId={props.deptId}
                                        //loading={props.loading}
                                        />
                                    </TabPanel>
                                </TabContext>

                            </div>
                        </Modal>
                    </div>
                )
            }
            <div className={classes.divPadding}>
                <Card className={classes.cardStyle}>
                    <Grid container spacing={6}>
                        <Grid item md={4} xs={12} sm={6}>
                            <Typography className={classes.title}>To Team Member</Typography>
                            <ReactSelect
                                placeholder="Select team Member"
                                options={teamMembers}
                                name="firstName"
                                value={
                                    teamMembers.filter((option: any) =>
                                        option.id === props.closeHoursData.closeHours?.teamMemberId)
                                }
                                onChange={handleTeamMembersOnchange}
                            />
                        </Grid>
                        <Grid item md={4} xs={12} sm={6} className={classes.gridMargin}>
                            <Typography className={classes.title}>To Department</Typography>
                            <ReactSelect placeholder="Select department"
                                options={depts}
                                name="name"
                                value={
                                    depts.filter((option: any) =>
                                        option.value === props.closeHoursData.closeHours?.departmentId)
                                }
                                onChange={handleDeptOnchange}
                            />
                        </Grid>
                    </Grid>
                    <div style={{ marginTop: 20 }}>
                        <Card className={classes.cardStyle}>
                            <Grid container spacing={2}>
                                <Grid item md={8} sm={9} xs={12}>
                                    <ThemeProvider theme={muiTheme}>
                                        <ReactAudioPlayer
                                            controls
                                            onLoadedMetadata={handleLoadMetadata}
                                            src={props.useDeptPath !== "" ? props.useDeptPath : ""}
                                            className={classes.audioPlayers}
                                        />
                                    </ThemeProvider>
                                    <div style={{ textAlign: 'left', marginTop: '-12px' }}>
                                        <span className={classes.filename}>{props?.userDeptPathName}</span>
                                    </div>
                                </Grid>
                                <Grid item md={4} sm={3} xs={12}> 
                                    <Button className={classes.editBtn} onClick={handlePopupModalAdd}>
                                        Edit
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
                </Card>
            </div>
        </>
    )
}

export default UsersDepartments